import { Component, OnInit } from '@angular/core';
import { MessagesPipe } from 'src/app/shared/pipes/messages.pipe';
import { NavigatorRefreshService } from 'src/app/shared/services/navigator.refresh.service';

@Component({
  selector: 'app-dinning-position',
  templateUrl: './dinning-position.component.html',
  styleUrls: ['./dinning-position.component.scss']
})
export class DinningPositionComponent implements OnInit {
  messagesPipe = new MessagesPipe();

  constructor(private navigatorRefreshService: NavigatorRefreshService) { }

  ngOnInit() {
    this.navigatorRefreshService.emitMenuRefreshLinkEvent(
      this.messagesPipe.transform('menu_dinning_position')
    );
  }

}
